import React, {useEffect} from "react";

import "./ThanksModal.scss"
import Shares from "../Shares/Shares";
import { virtualPageView } from "../Analytics/Analytics";

function ThanksModal(props) {
  useEffect(() => {
    virtualPageView(window.location.hostname + window.location.pathname + "end", "End");
  }, [])
  return (
    <div className="thanks-modal-container" onClick={props.onClickHandle}>
      <div className="e-container">
        <h1 className="title">תודה על השתתפותך!</h1>
        <h2>התוצאות יחשפו בפרויקט מיוחד של ynet ומוסף "7 לילות"</h2>
        <Shares label="Finish Popup"/>
      </div>
      <div className="bg">
        <div className="color"></div>
      </div>
    </div>
  );
}

export default ThanksModal;
